import { render, staticRenderFns } from "./CustomRangeAge.vue?vue&type=template&id=80e212b0&scoped=true"
import script from "./CustomRangeAge.vue?vue&type=script&lang=js"
export * from "./CustomRangeAge.vue?vue&type=script&lang=js"
import style0 from "./CustomRangeAge.vue?vue&type=style&index=0&id=80e212b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e212b0",
  null
  
)

export default component.exports